<fa-icon
  [icon]="faInfoCircle"
  class="wilson-handbook-info-icon"
  nz-popover
  [nzPopoverPlacement]="placement()"
  [nzPopoverContent]="popoverTpl"
  [nzPopoverTitle]="title()"
  nzPopoverTrigger="hover"
  nzPopoverOverlayClassName="wilson-handbook-info-popover"
  [nzPopoverOverlayStyle]="popoverOverlayStyle"
  size="xs"
/>
<ng-template #popoverTpl>
  <section class="wilson-handbook-info-content">
    <p>{{ content() }}</p>
    @if (resolvedLinkUrl() && linkText()) {
      <a [href]="resolvedLinkUrl()!" target="_blank" rel="noopener noreferrer">
        {{ linkText() }}
        <fa-icon [icon]="faSquareArrowUpRight" />
      </a>
    }
  </section>
</ng-template>
